import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { AppComponent } from 'src/app/app.component';


@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent {
  constructor(private location: Location, private appComponent:AppComponent) {
    this.appComponent.route.subscribe((route)=>{
      this.isActive = (route == "/control-ingreso/dependencias") ? true : false;
    });
  }
  isActive: boolean=false;
  ngOnInit(): void {
    const currentPath = this.location.path();
    this.isActive = (currentPath === "/control-ingreso/dependencias") ? true : false;
  }
}
